<script setup lang="ts">
import PrimeTimeline from 'primevue/timeline'

export type TimelineAlign = 'left' | 'right' | 'top' | 'bottom' | 'alternate'
export type TimelineLayout = 'vertical' | 'horizontal'

interface Props<T = unknown> {
  /** Items to render. Each item is passed to slot scope as `item`. */
  value: T[]
  /** Alignment of the connector axis. Default `left`. */
  align?: TimelineAlign
  /** Orientation. Default `vertical`. */
  layout?: TimelineLayout
}

defineProps<Props>()
</script>

<template>
  <PrimeTimeline :value="value" :align="align" :layout="layout">
    <template v-if="$slots.marker" #marker="slotProps">
      <slot name="marker" v-bind="slotProps" />
    </template>
    <template v-if="$slots.content" #content="slotProps">
      <slot name="content" v-bind="slotProps" />
    </template>
    <template v-if="$slots.opposite" #opposite="slotProps">
      <slot name="opposite" v-bind="slotProps" />
    </template>
  </PrimeTimeline>
</template>
